import {
  SHIPMENTS_PAGINATED_FETCH_STARTED,
  SHIPMENTS_PAGINATED_FETCH_SUCCEEDED,
  SHIPMENTS_PAGINATED_FETCH_FAILED,
  SHIPMENTS_PAGINATED_CHANGE_PAGE,
  SHIPMENTS_PAGINATED_CHANGE_ITEMS_PER_PAGE,
  SHIPMENTS_PAGINATED_CHANGE_ORDER,
  SHIPMENTS_PAGINATED_CHANGE_ORDER_BY,
  SHIPMENTS_PAGINATED_CHANGE_ORDER_AND_ORDER_BY,
  SHIPMENTS_PAGINATED_SET_FILTER,
  SHIPMENTS_PAGINATED_CLEAR
} from '#action/types';
import { requestStatuses as statuses, getShipmentStatusByCode } from '#helper';

const defaultState = {
  status: statuses.idle,
  shipments: [],
  error: null,
  page: 1,
  itemsPerPage: 50,
  order: 'asc',
  orderBy: 'startDate',
  pages: 0,
  filter: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SHIPMENTS_PAGINATED_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case SHIPMENTS_PAGINATED_FETCH_SUCCEEDED:
      const { logs = [], shipments = [], devices = [] } = action.payload;
      return {
        ...state,
        status: statuses.succeeded,
        shipments: shipments.map(s => ({
          ...s,
          status: getShipmentStatusByCode(s.status),
          logs: logs.filter(log => log?.shipment?.id === s.id),
          devices: s.devices?.map(d => ({ ...d, ...devices.find(f => f.id === d.id) }))
        })),
        pages: Math.ceil(action.totalCount / state.itemsPerPage)
      };
    case SHIPMENTS_PAGINATED_FETCH_FAILED:
      return { ...state, status: statuses.failed, shipments: [], error: action.error };
    case SHIPMENTS_PAGINATED_CHANGE_PAGE:
      return { ...state, page: action.payload };
    case SHIPMENTS_PAGINATED_CHANGE_ITEMS_PER_PAGE:
      return { ...state, itemsPerPage: action.payload };
    case SHIPMENTS_PAGINATED_CHANGE_ORDER:
      return { ...state, order: action.payload };
    case SHIPMENTS_PAGINATED_CHANGE_ORDER_BY:
      return { ...state, orderBy: action.payload };
    case SHIPMENTS_PAGINATED_CHANGE_ORDER_AND_ORDER_BY:
      return { ...state, order: action.payload.order, orderBy: action.payload.orderBy };
    case SHIPMENTS_PAGINATED_SET_FILTER:
      return { ...state, filter: action.payload };
    case SHIPMENTS_PAGINATED_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
